import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["initialFocus"]
  static values = { id: String, openOnConnect: Boolean }

  connect() {
    if (this.openOnConnectValue) this.show()
  }

  disconnect() {
    if (!document.querySelector("dialog[open]")) {
      document.body.classList.remove("modal-shown")
    }
  }

  get dialog() {
    return this.element instanceof HTMLDialogElement
      ? this.element
      : document.getElementById(this.idValue)
  }

  open(event) {
    event.preventDefault()

    const dialog = this.dialog
    if (!dialog) return

    if (!dialog.open) dialog.showModal()
    document.body.classList.add("modal-shown")

    dialog.dispatchEvent(
      new CustomEvent("portal:turbo-modal:open", {
        detail: { opener: event.currentTarget },
      })
    )
  }

  show(event) {
    const dialog = this.dialog
    if (!dialog) return

    this.opener = event?.detail?.opener || document.activeElement

    if (!dialog.open) dialog.showModal()

    document.body.classList.add("modal-shown")
    requestAnimationFrame(() => {
      if (this.hasInitialFocusTarget) this.initialFocusTarget.focus()
    })
  }

  close(event) {
    event?.preventDefault()
    this.dialog?.close()
  }

  backdropClick(event) {
    if (event.target === this.dialog) this.close()
  }

  closed() {
    if (!document.querySelector("dialog[open]")) {
      document.body.classList.remove("modal-shown")
    }

    this.opener?.focus({ preventScroll: true })
    this.opener = null
  }
}
